import { render } from "./CurriculumEditTableCell.vue?vue&type=template&id=fc3271d6&scoped=true&ts=true"
import script from "./CurriculumEditTableCell.vue?vue&type=script&lang=ts"
export * from "./CurriculumEditTableCell.vue?vue&type=script&lang=ts"

import "./CurriculumEditTableCell.vue?vue&type=style&index=0&id=fc3271d6&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc3271d6"]])

export default __exports__